import { Outlet } from 'react-router-dom';
import {
  SidebarInset,
  SidebarProvider,
} from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/sidebar';
import {
  Home,
  ClipboardCheck,
  Settings,
  Database,
  BarChart2,
  Users,
} from 'lucide-react';
import Header from '@/components/header';
import { useAuth } from '@/hooks/use-auth';

// All available menu items
const allSidebarItems = [
  {
    title: 'Home',
    url: '/home',
    icon: Home,
    roles: ['SYSTEM_ADMIN', 'PLATFORM_TEAM', 'PLATFORM_ADMIN'],
  },
  {
    title: 'Review Requests',
    url: '/review',
    icon: ClipboardCheck,
    roles: ['SYSTEM_ADMIN', 'PLATFORM_TEAM', 'PLATFORM_ADMIN'],
  },
  {
    title: 'IT Tasks',
    url: '/it-tasks',
    icon: Settings,
    roles: ['SYSTEM_ADMIN', 'IT_TEAM', 'IT_ADMIN'],
  },
  {
    title: 'Data Tasks',
    url: '/data-tasks',
    icon: Database,
    roles: ['SYSTEM_ADMIN', 'DATA_TEAM', 'DATA_ADMIN'],
  },
  {
    title: 'Activation',
    url: '/activation',
    icon: BarChart2,
    roles: ['SYSTEM_ADMIN', 'PLATFORM_TEAM', 'PLATFORM_ADMIN'],
  },
  {
    title: 'Users',
    url: '/users',
    icon: Users,
    roles: ['SYSTEM_ADMIN', 'IT_ADMIN', 'DATA_ADMIN', 'PLATFORM_ADMIN'],
  },
];

export function SidebarLayout() {
  const { user } = useAuth();

  // Filter items based on user role
  const sidebarItems = allSidebarItems.filter(
    (item) => user && item.roles.includes(user.role)
  );

  return (
    <SidebarProvider>
      <AppSidebar items={sidebarItems} />
      <SidebarInset>
        <Header/>
        <main className="flex flex-1 flex-col gap-4 p-8">
          <div className="w-full max-w-5xl mx-auto">
            <Outlet />
          </div>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
